export default __webpack_public_path__ + "static/media/imagem-2.098efadc.png";